import paths from "@ingka/icons-shared/paths/chevron-left";
import { renderPaths } from "../renderPaths.mjs";
var chevron_left_default = () => renderPaths(paths);
export {
  chevron_left_default as default
};
